import { Component, Input, ViewChild, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CdkPortal } from '@angular/cdk/portal';
import { OverlayRef, Overlay, OverlayConfig } from '@angular/cdk/overlay';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent implements OnDestroy {
  @Input() title!: string;
  @Input() closeIcon = true;
  @Input() width!: string;
  @Input() disposeOnNavigation = true;

  @ViewChild(CdkPortal) contentTemplate!: CdkPortal;

  private overlayRef!: OverlayRef;
  public isVisible = false;

  constructor(private overlay: Overlay, private cdr: ChangeDetectorRef) {}

  private getOverlayConfig(): OverlayConfig {
    const positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();

    return new OverlayConfig({
      positionStrategy,
      hasBackdrop: false,
      disposeOnNavigation: this.disposeOnNavigation,
      width: this.width,
    });
  }

  public open(): void {
    this.isVisible = true;
    this.overlayRef = this.overlay.create(this.getOverlayConfig());
    this.overlayRef.attach(this.contentTemplate);
  }

  public close(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef.dispose();
    }
  }

  public closeAnimation(): void {
    this.isVisible = false;
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.close();
  }
}
